import React from 'react';
import { FileText } from 'lucide-react';
import { Badge } from '@exiftrator/shared/components/ui';
import { EXIF_FIELDS } from '../../../config/fieldDefinitions';
import SettingsEntityCard from '../components/SettingsEntityCard';

function PresetCard({ preset, onEdit, onDelete }) {
  const valueLines = [];

  for (const fieldId of preset.includedFields || []) {
    const field = EXIF_FIELDS[fieldId];
    if (!field) continue;

    const value = preset.values?.[fieldId];
    if (value === null || value === undefined || value === '') continue;

    let displayValue = value;
    if (typeof displayValue === 'number' && Number.isFinite(displayValue)) {
      displayValue = field.type === 'gps-coordinate' ? displayValue.toFixed(6) : String(displayValue);
    }

    valueLines.push(`${field.label}: ${displayValue}`);
  }

  const valuePreview = valueLines.slice(0, 3);

  return (
    <SettingsEntityCard
      title={preset.name}
      icon={FileText}
      badge={
        <Badge variant="secondary" size="sm">
          {preset.includedFields?.length || 0} field{(preset.includedFields?.length || 0) === 1 ? '' : 's'}
        </Badge>
      }
      metadata={
        valuePreview.length > 0 ? (
          <div className="space-y-0.5 font-mono text-[11px]">
            {valuePreview.map((line) => (
              <p key={line} className="truncate" title={line}>
                {line}
              </p>
            ))}
            {valueLines.length > valuePreview.length ? (
              <p className="text-text-supporting/70">+{valueLines.length - valuePreview.length} more</p>
            ) : null}
          </div>
        ) : (
          <p className="italic">No preset values configured.</p>
        )
      }
      onEdit={() => onEdit?.(preset)}
      onDelete={() => onDelete?.(preset)}
    />
  );
}

export default PresetCard;
